module.exports = __webpack_public_path__ + "img/fldc.f740870d.svg";